@if (data(); as data) {
  @if (data.isLocked) {
    <div
      class="mb-8 flex items-center rounded-md bg-orange-100 p-6 text-orange-600"
      role="alert">
      <span
        class="mr-3 flex rounded-full bg-orange-600 px-2 py-1 text-xs font-bold text-white uppercase"
        >UWAGA</span
      >
      <span class="mr-2 flex-auto text-left font-semibold">
        <div>
          Subskrypcja jest właśnie przetwarzana. W tym czasie nie można
          wprowadzać zmian.
        </div>
        <div>
          Jeśli chcesz wprowadzać zmiany wróć za chwilę, gdy proces się
          zakończy.
        </div>
      </span>
    </div>
  }

  <div class="flex flex-col gap-6 text-sm">
    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Subskrypcja #{{ data.number }}</h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Status subskrypcji">
            <app-subscription-status [status]="data.status" />
          </app-details-view>

          <app-details-view label="Data ostatnie pomyślnej płatności">
            <app-date [date]="data.lastPaymentDate" />
          </app-details-view>

          @if (isNotNil(data.nextPaymentDate)) {
            <app-details-view label="Data następnej płatności">
              <app-date [date]="data.nextPaymentDate" />
            </app-details-view>
          }

          @if (isNotNil(data.cardChargeDay)) {
            <app-details-view label="Dzień obciążęnia karty">
              {{ data.cardChargeDay }} dzień miesiąca
            </app-details-view>
          }

          @if (isNotNil(data.cancelledDate)) {
            <app-details-view label="Data anulowania subskrypcji">
              <app-date [date]="data.cancelledDate" />
            </app-details-view>
          }

          <app-details-view label="Metoda płatności">
            {{ data.paymentMethod.name }}
          </app-details-view>

          <app-details-view label="Miesięczna cena subskrypcji">
            <app-currency [amount]="data.totalPrice" />
          </app-details-view>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>Podsumowanie subskrypcji</h5>

      <p-divider appPrimengDivider />

      <div class="flex flex-col gap-3">
        <app-details-view label="Produkty w subskrypcji">
          <div class="flex flex-col gap-3">
            @for (
              item of data.items;
              track item;
              let index = $index;
              let count = $count
            ) {
              <div class="relative flex items-center gap-3 bg-gray-50 p-6">
                @if (count > 1) {
                  <div
                    class="absolute top-0 left-0 flex size-6 items-center justify-center bg-gray-300 text-sm">
                    {{ index + 1 }}.
                  </div>
                }

                @if (isNotNil(item.featuredFile)) {
                  <div>
                    <app-image-thumbnail size="md">
                      <img
                        [fill]="true"
                        [ngSrc]="item.featuredFile.url"
                        [alt]="item.featuredFile.alt" />
                    </app-image-thumbnail>
                  </div>
                }

                <div class="flex flex-1 justify-between gap-3">
                  <div class="flex items-center gap-3">
                    <div class="flex flex-col">
                      @if (item.canShowNameAsLink) {
                        <app-public-product-name
                          [slug]="item.slug!"
                          [type]="item.type!">
                          <div class="font-bold hover:underline">
                            {{ item.name }}
                          </div>
                        </app-public-product-name>
                      } @else {
                        <div class="font-bold">{{ item.name }}</div>
                      }
                    </div>

                    <div class="flex items-center gap-1">
                      <span class="text-xs">x</span>
                      <span class="text-xs">{{ item.quantity }} szt.</span>
                    </div>
                  </div>

                  <div class="ms-auto font-bold">
                    <app-currency [amount]="item.price" />
                  </div>
                </div>
              </div>
            } @empty {
              <app-no-data />
            }
          </div>
        </app-details-view>

        <div class="flex flex-col gap-3 bg-gray-50 px-6 py-3">
          <div class="flex items-center gap-3">
            <div class="font-bold">Kwota</div>

            <div class="ms-auto font-bold">
              <app-currency [amount]="data.itemsPrice" />
            </div>
          </div>

          <div class="flex items-center gap-3">
            <div class="font-bold">{{ data.shippingMethod.name }}</div>

            <div class="ms-auto font-bold">
              <app-currency [amount]="data.shippingPrice" />
            </div>
          </div>

          <p-divider appPrimengDivider />

          <div class="flex items-center gap-3">
            <div class="font-bold">Łącznie</div>

            <div class="ms-auto font-bold">
              <app-currency [amount]="data.totalPrice" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>
        <div class="flex items-center gap-3">
          <div>Adres rozliczeniowy</div>
          @if (data.canBillingAddressBeUpdated) {
            <div class="ms-auto">
              <p-button
                (onClick)="handleBillingAddressUpdateClick()"
                pTooltip="Edytuj adres rozliczeniowy"
                [text]="true">
                <app-icon [icon]="Icon.Pencil" />
              </p-button>
            </div>
          }
        </div>
      </h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Imie i nazwisko">
            <div class="flex gap-1">
              <span>{{ data.billingAddress.firstName }}</span>
              <span>{{ data.billingAddress.lastName }}</span>
            </div>
          </app-details-view>

          <app-details-view label="Adres e-mail">
            {{ data.billingAddress.email }}
          </app-details-view>

          <app-details-view label="Numer telefonu">
            {{ data.billingAddress.phone.numberWithPrefix }}
          </app-details-view>

          <app-details-view label="Adres">
            {{ data.billingAddress.asString }}
          </app-details-view>

          <app-details-view label="Nazwa firmy">
            @if (isNotNil(data.billingAddress.companyName)) {
              {{ data.billingAddress.companyName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>

          <app-details-view label="NIP firmy">
            @if (isNotNil(data.billingAddress.companyNip)) {
              {{ data.billingAddress.companyNip }}
            } @else {
              <app-no-data />
            }
          </app-details-view>
        </div>
      </div>
    </div>

    <div class="rounded-sm border border-gray-200 p-4">
      <h5>
        <div class="flex items-center gap-3">
          <div>Adres dostawy</div>

          @if (data.canShippingAddressBeUpdated) {
            <div class="ms-auto">
              <p-button
                (onClick)="handleShippingAddressUpdateClick()"
                pTooltip="Edytuj adres dostawy"
                [text]="true">
                <app-icon [icon]="Icon.Pencil" />
              </p-button>
            </div>
          }
        </div>
      </h5>

      <p-divider appPrimengDivider />

      <div class="relative flex flex-col gap-1 bg-gray-50 p-6">
        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Imie i nazwisko">
            <div class="flex gap-1">
              <span>{{ data.shippingAddress.firstName }}</span>
              <span>{{ data.shippingAddress.lastName }}</span>
            </div>
          </app-details-view>

          <app-details-view label="Adres e-mail">
            {{ data.shippingAddress.email }}
          </app-details-view>

          <app-details-view label="Numer telefonu">
            {{ data.shippingAddress.phone.numberWithPrefix }}
          </app-details-view>

          <app-details-view label="Adres">
            {{ data.shippingAddress.asString }}
          </app-details-view>

          <app-details-view label="Nazwa firmy">
            @if (isNotNil(data.shippingAddress.companyName)) {
              {{ data.shippingAddress.companyName }}
            } @else {
              <app-no-data />
            }
          </app-details-view>
        </div>

        <p-divider
          appPrimengDivider
          class="mx-auto w-4/5" />

        <div class="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
          <app-details-view label="Sposób dostawy">
            {{ data.shippingMethod.name }}
          </app-details-view>

          @if (isNotNil(data.shippingAddress.shippingPointName)) {
            <div class="col-span-2">
              <app-details-view label="Punkt dostawy">
                {{ data.shippingAddress.shippingPointName }}
              </app-details-view>
            </div>
          }
        </div>
      </div>
    </div>

    @if (number$ | async; as number) {
      <div class="rounded-sm border border-gray-200 p-4">
        <h5>Powiązane zamówienia</h5>

        <p-divider appPrimengDivider />

        <app-public-subscription-order-list [number]="number" />
      </div>
    }
  </div>
} @else {
  <app-spinner-filled />
}

<p-drawer
  [customCloseEvent]="customCloseBillingAddressEditEvent"
  [visible]="billingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title
      >Edycja adresu rozliczeniowego subskrypcji</app-drawer-title
    >
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      <app-public-subscription-billing-address-edit
        (cancelEvent)="handleCancelBillingAddressEditEvent()"
        (submitEvent)="handleSubmitBillingAddressEditEvent()"
        [number]="number()" />
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customCloseShippingAddressEditEvent"
  [visible]="shippingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Edycja adresu dostawy subskrypcji</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      <app-public-subscription-shipping-address-edit
        (cancelEvent)="handleCancelShippingAddressEditEvent()"
        (submitEvent)="handleSubmitShippingAddressEditEvent()"
        [number]="number()" />
    </app-drawer-content>
  </ng-template>
</p-drawer>
